import { render, staticRenderFns } from "./LeadFormMobile.vue?vue&type=template&id=23ba3b90&scoped=true"
import script from "./LeadFormMobile.vue?vue&type=script&lang=js"
export * from "./LeadFormMobile.vue?vue&type=script&lang=js"
import style0 from "./LeadFormMobile.vue?vue&type=style&index=0&id=23ba3b90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba3b90",
  null
  
)

export default component.exports